export function isSvg(str) {
    return str.startsWith("<svg") || str.startsWith("<?xml");
}

export function isXML(str) {
    return str.startsWith("<");
}
//# sourceMappingURL=is-xml.js.map
